import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["form", "formField"]

  declare readonly formTarget: HTMLFormElement
  declare readonly formFieldTarget: HTMLInputElement

  openModal(event) {
    const modalEl = document.getElementById("logo-upload-modal")
    const modal = Modal.getOrCreateInstance(modalEl)

    const onSave = async (event) => {
      this.formFieldTarget.value = event.detail.imageId
      this.formTarget.requestSubmit()

      modal.hide()
    }

    function onModalHidden() {
      modalEl.removeEventListener("hidden.bs.modal", onModalHidden)
      modalEl.removeEventListener("saveUpload", onSave)
    }

    modalEl.addEventListener("hidden.bs.modal", onModalHidden)
    modalEl.addEventListener("saveUpload", onSave)

    modal.show()
  }
}
